import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Toast } from 'primereact/toast';
import classNames from 'classnames';

import { AutoComplete } from 'primereact/autocomplete';
import { MultiSelect } from 'primereact/multiselect';
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { TabView, TabPanel } from 'primereact/tabview';

import { useFormCreateCategory } from '../../controllers/Category/CreateCategoryController';
import { useFormCreateMileages } from '../../controllers/Mileages/CreateMileagesController';
import { useFormCreateFuelType } from '../../controllers/FuelType/CreateFuelTypeController';
import { useFormCreateVehicle } from '../../controllers/Vehicle/CreateVehiclesController';
import { useFormCreateStocks } from '../../controllers/Stocks/CreateStocksController';
import { useFormCreateBrands } from '../../controllers/Brands/CreateBrandsController';
import { useListUnitysController } from 'src/controllers/Unitys/ListUnitysController';
import { useFormCreateEspecie } from 'src/controllers/Especies/CreateEspecieController';

import DropzoneScreen from 'src/components/Dropzone/Dropzone';
import LoadingScreen from '../../components/LoadingScreen';
import { useData } from 'src/contexts/data';
import { Dropdown } from 'primereact/dropdown';

interface filteredFieldProps {
	label?: string;
	value?: string;
}

const VehicleForm: React.FC = () => {
	const [filteredCategories, setFilteredCategories] = useState<filteredFieldProps[]>([{ label: '', value: '' }]);
	const [filteredMileages, setFilteredMileages] = useState<filteredFieldProps[]>([{ label: '', value: '' }]);
	const [filteredStocks, setFilteredStocks] = useState<filteredFieldProps[]>([{ label: '', value: '' }]);
	const [filteredBrands, setFilteredBrands] = useState<filteredFieldProps[]>([{ label: '', value: '' }]);
	const [filteredUnity, setFilteredUnity] = useState<filteredFieldProps[]>([{ label: '', value: '' }]);
	const [filteredEspecie, setFilteredEspecie] = useState<filteredFieldProps[]>([{ label: '', value: '' }]);

	const [categoryResponse, setCategoryResponse] = useState<any[]>([]);
	const [mileageResponse, setMileageResponse] = useState<any[]>([]);
	const [brandResponse, setBrandResponse] = useState<any[]>([]);
	const [stockResponse, setStockResponse] = useState<any[]>([]);
	const [fuelResponse, setFuelResponse] = useState<any[]>([]);
	const [especieResponse, setEspecieResponse] = useState<any[]>([]);

	const [categoriesValue, setCategoriesValue] = useState('');
	const [mileagesValue, setMileagesValue] = useState('');
	const [stocksValue, setStocksValue] = useState('');
	const [brandsValue, setBrandsValue] = useState('');
	const [valueUnity, setValueUnity] = useState('');
	const [especieValue, setEspecieValue] = useState('');

	const { getCategoryFormController } = useFormCreateCategory();
	const { getMileageFormController } = useFormCreateMileages();
	const { getFuelFormController } = useFormCreateFuelType();
	const { getBrandFormController } = useFormCreateBrands();
	const { getStockFormController } = useFormCreateStocks();
	const { getEspecieFormController } = useFormCreateEspecie();

	const { getFormController, handleFormController } = useFormCreateVehicle();
	const { getUnityListController } = useListUnitysController();
	const { handleDelete } = useData();
	const history = useHistory();

	const [registerFinished, setRegisterFinished] = useState(false);

	useEffect(() => {
		if (getFormController.vehicleResponse?.status === 200) {
			setRegisterFinished(true);
		}
		if (getFormController.vehicleEditedResponse?.status === 200 && !getFormController.vehicleResponse) {
			setRegisterFinished(false);
			setCategoriesValue('');
			setMileagesValue('');
			setBrandsValue('');
			setStocksValue('');
			setValueUnity('');
			setEspecieValue('');
		}
		if (getCategoryFormController.categoryResponse?.status === 200) updateCategorys();
		if (getMileageFormController.mileageResponse?.status === 200) updateMileages();
		if (getBrandFormController.brandResponse?.status === 200) updateBrands();
		if (getStockFormController.stockResponse?.status === 200) updateStocks();
		if (getFuelFormController.fuelResponse?.status === 200) updateFuels();
		if (getEspecieFormController.especieResponse?.status === 200) updateEspecies();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [
		getCategoryFormController.categoryResponse,
		getMileageFormController.mileageResponse,
		getBrandFormController.brandResponse,
		getStockFormController.stockResponse,
		getFuelFormController.fuelResponse,
		getEspecieFormController.especieResponse,
		getFormController.vehicleResponse,
		getFormController.vehicleEditedResponse,
	]);

	const searchStock = (event: any) => {
		let filteredStocks;
		if (!event.query.trim().length) {
			filteredStocks = [...stock, ...stockResponse];
		} else {
			filteredStocks = [...stock, ...stockResponse].filter(stock => {
				return stock.label.toLowerCase().includes(event.query.toLowerCase());
			});
		}
		setFilteredStocks(filteredStocks);
	};

	const searchBrand = (event: any) => {
		let filteredBrands;
		if (!event.query.trim().length) {
			filteredBrands = [...brands, ...brandResponse];
		} else {
			filteredBrands = [...brands, ...brandResponse].filter(brand => {
				return brand.label.toLowerCase().includes(event.query.toLowerCase());
			});
		}
		setFilteredBrands(filteredBrands);
	};

	const searchMileages = (event: any) => {
		let filteredMileages;
		if (!event.query.trim().length) {
			filteredMileages = [...mileages, ...mileageResponse];
		} else {
			filteredMileages = [...mileages, ...mileageResponse].filter(mileage => {
				return mileage.label.toLowerCase().includes(event.query.toLowerCase());
			});
		}
		setFilteredMileages(filteredMileages);
	};

	const searchCategory = (event: any) => {
		let filteredCategories;
		if (!event.query.trim().length) {
			filteredCategories = [...categories, ...categoryResponse];
		} else {
			filteredCategories = [...categories, ...categoryResponse].filter(category => {
				return category.label.toLowerCase().includes(event.query.toLowerCase());
			});
		}
		setFilteredCategories(filteredCategories);
	};

	const searchEspecie = (event: any) => {
		let filteredEspecies;
		if (!event.query.trim().length) {
			filteredEspecies = [...especies, ...especieResponse];
		} else {
			filteredEspecies = [...especies, ...especieResponse].filter(Especie => {
				return Especie.label.toLowerCase().includes(event.query.toLowerCase());
			});
		}
		setFilteredEspecie(filteredEspecies);
	};

	const searchUnitys = (event: any) => {
		let filteredUnitys;
		if (!event.query.trim().length) {
			filteredUnitys = [...unitys];
		} else {
			filteredUnitys = unitys.filter(unity => {
				return unity.label.toLowerCase().includes(event.query.toLowerCase());
			});
		}

		setFilteredUnity(filteredUnitys);
	};

	const categories = getFormController.tablesData.categoriesData.map(category => {
		return { label: category.DESCRICAO, value: category.ID };
	});
	const especies = getFormController.tablesData.especiesData.map(especies => {
		return { label: especies.DESCRICAO, value: especies.ID };
	});
	const brands = getFormController.tablesData.brandsData.map(brand => {
		return { label: brand.DESCRICAO, value: brand.ID };
	});
	const mileages = getFormController.tablesData.mileagesData.map(mileage => {
		return { label: mileage.DESCRICAO, value: mileage.ID };
	});
	const stock = getFormController.tablesData.stocksData.map(stock => {
		return { label: stock.NOME, value: stock.ID };
	});
	const fuelType = getFormController.tablesData.fuelTypesData.map(stock => {
		return { label: stock.DESCRICAO, value: stock.ID };
	});
	const unitys = getUnityListController.AllUnitysData.map(unity => {
		return { label: unity.NOME, value: unity.ID };
	});
	const status = [
		{ label: 'Em manutenção', value: 0 },
		{ label: 'Pronto para uso', value: 1 },
	];

	const updateBrands = () => {
		handleFormController.closeFormDialog();
		let brandUpdate = {
			label: getBrandFormController.brandResponse?.data.DESCRICAO,
			value: getBrandFormController.brandResponse?.data.ID,
		};
		let brandList = [...brandResponse, brandUpdate];
		if (!!brandUpdate.value) {
			setBrandResponse(brandList);
			setBrandsValue(brandList[0].label);
			getFormController.formik.setFieldValue('FT_MARCA', brandList[0].value);
		}
	};

	const updateMileages = () => {
		handleFormController.closeFormDialog();
		let mileageUpdate = {
			label: getMileageFormController.mileageResponse?.data.DESCRICAO,
			value: getMileageFormController.mileageResponse?.data.ID,
		};
		let mileageList = [...mileageResponse, mileageUpdate];
		if (!!mileageUpdate.value) {
			setMileageResponse(mileageList);
			setMileagesValue(mileageList[0].label);
			getFormController.formik.setFieldValue('FT_TIPOQUILOMETRAGEM', mileageList[0].value);
		}
	};

	const updateStocks = () => {
		handleFormController.closeFormDialog();
		let stockUpdate = {
			label: getStockFormController.stockResponse?.data.NOME,
			value: getStockFormController.stockResponse?.data.ID,
		};
		let stockList = [...stockResponse, stockUpdate];
		if (!!stockUpdate.value) {
			setStockResponse(stockList);
			setStocksValue(stockList[0].label);
			getFormController.formik.setFieldValue('AX_ESTOQUE', stockList[0].value);
		}
	};

	const updateFuels = () => {
		handleFormController.closeFormDialog();
		let fuelUpdate = {
			label: getFuelFormController.fuelResponse?.data.DESCRICAO,
			value: getFuelFormController.fuelResponse?.data.ID,
		};
		let fuelList = [...fuelResponse, fuelUpdate];
		if (!!fuelUpdate.value) {
			setFuelResponse(fuelList);
		}
	};

	const updateCategorys = () => {
		handleFormController.closeFormDialog();
		let categoryUpdate = {
			label: getCategoryFormController.categoryResponse?.data.DESCRICAO,
			value: getCategoryFormController.categoryResponse?.data.ID,
		};
		let categoryList = [...categoryResponse, categoryUpdate];
		if (!!categoryUpdate.value) {
			setCategoryResponse(categoryList);
			setCategoriesValue(categoryList[0].label);
			getFormController.formik.setFieldValue('FT_CATEGORIA', categoryList[0].value);
		}
	};

	const updateEspecies = () => {
		handleFormController.closeFormDialog();
		let especieUpdate = {
			label: getEspecieFormController.especieResponse?.data.DESCRICAO,
			value: getEspecieFormController.especieResponse?.data.ID,
		};
		let especieList = [...especieResponse, especieUpdate];
		if (!!especieUpdate.value) {
			setEspecieResponse(especieList);
			setEspecieValue(especieList[0].label);
			getFormController.formik.setFieldValue('FT_ESPECIE', especieList[0].value);
		}
	};

	const extraFormDialogHeader = (
		<div className='p-fluid p-d-flex p-flex-row p-jc-between'>
			<div>
				<h5>Cadastrar {getFormController.selectedField}</h5>
			</div>
			<div>
				<Button
					label='Fechar'
					icon='pi pi-times'
					className='p-button-text p-fluid'
					onClick={handleFormController.closeFormDialog}
				/>
			</div>
		</div>
	);

	return (
		<div style={{ height: '100%' }} className='card p-align-center p-justify-center'>
			{getFormController.loading ? <LoadingScreen color='#0388e5' /> : <></>}
			<Toast ref={getFormController.toast} />
			<Toast ref={getStockFormController.toast} />
			<Toast ref={getBrandFormController.toast} />
			<Toast ref={getFuelFormController.toast} />
			<Toast ref={getMileageFormController.toast} />
			<Toast ref={getCategoryFormController.toast} />
			<Toast ref={getEspecieFormController.toast} />
			<h5>Cadastro de veículo</h5>

			<TabView>
				<TabPanel header="Dados Principais">
					<div className='p-grid p-fluid'>
						<div className='p-field p-col-12 p-md-3'>
							<label htmlFor='placa'>Placa</label>
							<InputText
								disabled={registerFinished}
								id='placa'
								maxLength={7}
								keyfilter='alphanum'
								{...getFormController.formik.getFieldProps('PLACA')}

								onChange={getFormController.formik.handleChange('PLACA')}
							/>
							<div
								className={classNames('p-invalid popup-fade', {
									'popup-form-active':
										getFormController.formik.touched.PLACA && getFormController.formik.errors.PLACA,
									'popup-form-inactive': !(
										getFormController.formik.touched.PLACA && getFormController.formik.errors.PLACA
									),
								})}>
								{getFormController.formik.errors.PLACA}
							</div>
						</div>

						<div className='p-field p-col-12 p-md-3'>
							<label htmlFor='estoque'>Estoque</label>
							<div className='p-inputgroup'>
								<Button
									type='button'
									icon='pi pi-plus'
									className='p-button-primary '
									onClick={() => handleFormController.openFormDialog('Estoque')}
								/>
								<AutoComplete
									disabled={registerFinished}
									id='estoque'
									dropdown
									placeholder='Buscar...'
									value={stocksValue}
									onChange={e => {
										setStocksValue(e.value);
										getFormController.formik.setFieldValue(
											'AX_ESTOQUE',
											filteredStocks.find(stock => {
												return e.value === stock.label;
											})?.value || '',
										);
									}}
									onSelect={e => {
										getFormController.formik.setFieldValue('AX_ESTOQUE', e.value.value);
										setStocksValue(e.value.label);
									}}
									suggestions={filteredStocks}
									field='label'
									completeMethod={searchStock}
								/>
							</div>

							<div
								className={classNames('p-invalid popup-fade', {
									'popup-form-active':
										getFormController.formik.touched.AX_ESTOQUE &&
										getFormController.formik.errors.AX_ESTOQUE,
									'popup-form-inactive': !(
										getFormController.formik.touched.AX_ESTOQUE &&
										getFormController.formik.errors.AX_ESTOQUE
									),
								})}>
								{getFormController.formik.errors.AX_ESTOQUE}
							</div>
						</div>

						<div className='p-field p-col-12 p-md-3'>
							<label htmlFor='status'>Status de veículo</label>
							<Dropdown
								id='status'
								value={getFormController.formik.values.STATUS}
								onChange={e => getFormController.formik.setFieldValue('STATUS', e.value)}
								options={status}
							/>
							<div
								className={classNames('p-invalid popup-fade', {
									'popup-form-active':
										getFormController.formik.touched.STATUS && getFormController.formik.errors.STATUS,
									'popup-form-inactive': !(
										getFormController.formik.touched.STATUS && getFormController.formik.errors.STATUS
									),
								})}>
								{getFormController.formik.errors.STATUS}
							</div>
						</div>

						<div className='p-field p-col-12 p-md-3'>
							<label htmlFor='marca'>Marca</label>
							<div className='p-inputgroup'>
								<Button
									type='button'
									icon='pi pi-plus'
									className='p-button p-button-primary '
									onClick={() => handleFormController.openFormDialog('Marca')}
								/>
								<AutoComplete
									disabled={registerFinished}
									id='marca'
									dropdown
									placeholder='Buscar...'
									value={brandsValue} 
									onChange={e => {
										setBrandsValue(e.value);
										getFormController.formik.setFieldValue(
											'FT_MARCA',
											filteredBrands.find(brand => {
												return e.value === brand.label;
											})?.value || '',
										);
									}}
									onSelect={e => {
										getFormController.formik.setFieldValue('FT_MARCA', e.value.value);
										setBrandsValue(e.value.label);
									}}
									suggestions={filteredBrands}
									field='label'
									completeMethod={searchBrand}
								/>
							</div>
							<div
								className={classNames('p-invalid popup-fade', {
									'popup-form-active':
										getFormController.formik.touched.FT_MARCA && getFormController.formik.errors.FT_MARCA,
									'popup-form-inactive': !(
										getFormController.formik.touched.FT_MARCA && getFormController.formik.errors.FT_MARCA
									),
								})}>
								{getFormController.formik.errors.FT_MARCA}
							</div>
						</div>



						<div className='p-field p-col-12 p-md-3'>
							<label htmlFor='tipoCombustivel'>Tipo de combustível</label>
							<div className='p-inputgroup'>
								<Button
									type='button'
									icon='pi pi-plus'
									className='p-button p-button-primary '
									onClick={() => handleFormController.openFormDialog('Tipo de combustível')}
								/>
								<MultiSelect
									id='tipoCombustivel'
									disabled={registerFinished}
									{...getFormController.formik.getFieldProps('TIPOCOMBUSTIVEL.ID')}
									onChange={e => {
										getFormController.formik.setFieldValue('TIPOCOMBUSTIVEL.ID', e.value);
									}}
									options={[...fuelType, ...fuelResponse]}
									optionLabel='label'
									className='multiselect-custom'
									placeholder='Selecionar...'
								/>
							</div>
							<div
								className={classNames('p-invalid popup-fade', {
									'popup-form-active':
										getFormController.formik.touched.TIPOCOMBUSTIVEL &&
										getFormController.formik.errors.TIPOCOMBUSTIVEL,
									'popup-form-inactive': !(
										getFormController.formik.touched.TIPOCOMBUSTIVEL &&
										getFormController.formik.errors.TIPOCOMBUSTIVEL
									),
								})}>
								{getFormController.formik.errors.TIPOCOMBUSTIVEL}
							</div>
						</div>

						



						<div className='p-field p-col-12 p-md-3'>
							<label htmlFor='corVeiculo'>Cor</label>
							<InputText
								disabled={registerFinished}
								id='corVeiculo'
								maxLength={10}
								{...getFormController.formik.getFieldProps('COR')}
								onChange={getFormController.formik.handleChange('COR')}
							/>
							<div
								className={classNames('p-invalid popup-fade', {
									'popup-form-active':
										getFormController.formik.touched.COR && getFormController.formik.errors.COR,
									'popup-form-inactive': !(
										getFormController.formik.touched.COR && getFormController.formik.errors.COR
									),
								})}>
								{getFormController.formik.errors.COR}
							</div>
						</div>





						<div className='p-field p-col-12 p-md-4'>
							<label htmlFor='unidade'>Setor</label>
							<AutoComplete
								disabled={registerFinished}
								id='unidade'
								value={valueUnity}
								field='label'
								onChange={e => {
									setValueUnity(e.value);
									getFormController.formik.setFieldValue(
										'ORGAOUNIDADE',
										filteredUnity.find(unity => {
											return e.value === unity.label;
										})?.value || '',
									);
								}}
								onSelect={e => {
									setValueUnity(e.value.label);
									getFormController.formik.setFieldValue('ORGAOUNIDADE', e.value.value);
								}}
								suggestions={filteredUnity}
								completeMethod={searchUnitys}
								dropdown
								placeholder='Buscar...'
							/>
							<div
								className={classNames('p-invalid popup-fade', {
									'popup-form-active':
										getFormController.formik.touched.ORGAOUNIDADE &&
										getFormController.formik.errors.ORGAOUNIDADE,
									'popup-form-inactive': !(
										getFormController.formik.touched.ORGAOUNIDADE &&
										getFormController.formik.errors.ORGAOUNIDADE
									),
								})}>
								{getFormController.formik.errors.ORGAOUNIDADE}
							</div>
						</div>



						<div className='p-field p-col-12'>
							<label htmlFor='ultVenda'>Foto do documento do veículo</label>
							<div
								style={registerFinished ? { pointerEvents: 'none', opacity: 0.5 } : {}}
								className='p-fileupload'>
								<DropzoneScreen />
							</div>
						</div>
					</div>
				</TabPanel>
				<TabPanel header="Dados secundários">
					<div className='p-grid p-fluid'>
						<div className='p-field p-col-12 p-md-3'>
							<label htmlFor='descricao'>Descrição</label>
							<InputText
								disabled={registerFinished}
								id='descricao'
								maxLength={150}
								{...getFormController.formik.getFieldProps('DESCRICAO')}
								onChange={getFormController.formik.handleChange('DESCRICAO')}
							/>
							<div
								className={classNames('p-invalid popup-fade', {
									'popup-form-active':
										getFormController.formik.touched.DESCRICAO && getFormController.formik.errors.DESCRICAO,
									'popup-form-inactive': !(
										getFormController.formik.touched.DESCRICAO && getFormController.formik.errors.DESCRICAO
									),
								})}>
								{getFormController.formik.errors.DESCRICAO}
							</div>
						</div>
						<div className='p-field p-col-12 p-md-3'>
							<label htmlFor='sigla'>Sigla</label>
							<InputText
								disabled={registerFinished}
								id='sigla'
								maxLength={15}
								{...getFormController.formik.getFieldProps('SIGLA')}
							/>
							<div
								className={classNames('p-invalid popup-fade', {
									'popup-form-active':
										getFormController.formik.touched.SIGLA && getFormController.formik.errors.SIGLA,
									'popup-form-inactive': !(
										getFormController.formik.touched.SIGLA && getFormController.formik.errors.SIGLA
									),
								})}>
								{getFormController.formik.errors.SIGLA}
							</div>
						</div>
						<div className='p-field p-col-12 p-md-2'>
							<label htmlFor='marcadorKm'>Quilometragem</label>
							<InputText
								disabled={registerFinished}
								id='marcadorKm'
								keyfilter='num'
								{...getFormController.formik.getFieldProps('MARCADORKM')}
								onChange={getFormController.formik.handleChange('MARCADORKM')}
							/>
							<div
								className={classNames('p-invalid popup-fade', {
									'popup-form-active':
										getFormController.formik.touched.MARCADORKM &&
										getFormController.formik.errors.MARCADORKM,
									'popup-form-inactive': !(
										getFormController.formik.touched.MARCADORKM &&
										getFormController.formik.errors.MARCADORKM
									),
								})}>
								{getFormController.formik.errors.MARCADORKM}
							</div>
						</div>
						<div className='p-field p-col-12 p-md-3'>
							<label htmlFor='renavam'>Ranavam</label>
							<InputText
								disabled={registerFinished}
								id='renavam'
								maxLength={11}
								{...getFormController.formik.getFieldProps('RENAVAM')}
								onChange={getFormController.formik.handleChange('RENAVAM')}
							/>
							<div
								className={classNames('p-invalid popup-fade', {
									'popup-form-active':
										getFormController.formik.touched.RENAVAM && getFormController.formik.errors.RENAVAM,
									'popup-form-inactive': !(
										getFormController.formik.touched.RENAVAM && getFormController.formik.errors.RENAVAM
									),
								})}>
								{getFormController.formik.errors.RENAVAM}
							</div>
						</div>
						<div className='p-field p-col-12 p-md-6'>
							<label htmlFor='chassi'>Número Chassi</label>
							<InputText
								disabled={registerFinished}
								id='chassi'
								maxLength={17}
								{...getFormController.formik.getFieldProps('NUMEROCHASSI')}
								onChange={getFormController.formik.handleChange('NUMEROCHASSI')}
							/>
							<div
								className={classNames('p-invalid popup-fade', {
									'popup-form-active':
										getFormController.formik.touched.NUMEROCHASSI &&
										getFormController.formik.errors.NUMEROCHASSI,
									'popup-form-inactive': !(
										getFormController.formik.touched.NUMEROCHASSI &&
										getFormController.formik.errors.NUMEROCHASSI
									),
								})}>
								{getFormController.formik.errors.NUMEROCHASSI}
							</div>
						</div>
						<div className='p-field p-col-12 p-md-3'>
							<label htmlFor='anoFab'>Ano de fabricação</label>
							<InputText
								disabled={registerFinished}
								id='anoFab'
								maxLength={4}
								{...getFormController.formik.getFieldProps('ANOFABRICACAO')}
								onChange={getFormController.formik.handleChange('ANOFABRICACAO')}
							/>
							<div
								className={classNames('p-invalid popup-fade', {
									'popup-form-active':
										getFormController.formik.touched.ANOFABRICACAO &&
										getFormController.formik.errors.ANOFABRICACAO,
									'popup-form-inactive': !(
										getFormController.formik.touched.ANOFABRICACAO &&
										getFormController.formik.errors.ANOFABRICACAO
									),
								})}>
								{getFormController.formik.errors.ANOFABRICACAO}
							</div>
						</div>

						<div className='p-field p-col-12 p-md-3'>
							<label htmlFor='anoModelo'>Ano do modelo</label>
							<InputText
								disabled={registerFinished}
								id='anoModelo'
								maxLength={4}
								{...getFormController.formik.getFieldProps('ANOMODELO')}
								onChange={getFormController.formik.handleChange('ANOMODELO')}
							/>
							<div
								className={classNames('p-invalid popup-fade', {
									'popup-form-active':
										getFormController.formik.touched.ANOMODELO && getFormController.formik.errors.ANOMODELO,
									'popup-form-inactive': !(
										getFormController.formik.touched.ANOMODELO && getFormController.formik.errors.ANOMODELO
									),
								})}>
								{getFormController.formik.errors.ANOMODELO}
							</div>
						</div>
						<div className='p-field p-col-12 p-md-3'>
							<label htmlFor='capCombustivel'>Capacidade de combustível</label>
							<InputText
								disabled={registerFinished}
								id='capCombustivel'
								placeholder='Exemplos: 4 ou 4.2'
								keyfilter='num'
								{...getFormController.formik.getFieldProps('CAPACIDADECOMBUSTIVEL')}
							/>
							<div
								className={classNames('p-invalid popup-fade', {
									'popup-form-active':
										getFormController.formik.touched.CAPACIDADECOMBUSTIVEL &&
										getFormController.formik.errors.CAPACIDADECOMBUSTIVEL,
									'popup-form-inactive': !(
										getFormController.formik.touched.CAPACIDADECOMBUSTIVEL &&
										getFormController.formik.errors.CAPACIDADECOMBUSTIVEL
									),
								})}>
								{getFormController.formik.errors.CAPACIDADECOMBUSTIVEL}
							</div>
						</div>

						<div className='p-field p-col-12 p-md-3'>
							<label htmlFor='categoria'>Categoria</label>
							<div className='p-inputgroup'>
								<Button
									type='button'
									icon='pi pi-plus'
									className='p-button p-button-primary '
									onClick={() => handleFormController.openFormDialog('Categoria')}
								/>
								<AutoComplete
									disabled={registerFinished}
									id='categoria'
									dropdown
									placeholder='Buscar...'
									value={categoriesValue}
									onChange={e => {
										setCategoriesValue(e.value);
										getFormController.formik.setFieldValue(
											'FT_CATEGORIA',
											filteredCategories.find(category => {
												return e.value === category.label;
											})?.value || '',
										);
									}}
									onSelect={e => {
										getFormController.formik.setFieldValue('FT_CATEGORIA', e.value.value);
										setCategoriesValue(e.value.label);
									}}
									suggestions={filteredCategories}
									field='label'
									completeMethod={searchCategory}
								/>
							</div>
							<div
								className={classNames('p-invalid popup-fade', {
									'popup-form-active':
										getFormController.formik.touched.FT_CATEGORIA &&
										getFormController.formik.errors.FT_CATEGORIA,
									'popup-form-inactive': !(
										getFormController.formik.touched.FT_CATEGORIA &&
										getFormController.formik.errors.FT_CATEGORIA
									),
								})}>
								{getFormController.formik.errors.FT_CATEGORIA}
							</div>
						</div>

						<div className='p-field p-col-12 p-md-4'>
							<label htmlFor='tipokm'>Tipo Quilometragem</label>
							<div className='p-inputgroup'>
								<Button
									type='button'
									icon='pi pi-plus'
									className='p-button p-button-primary '
									onClick={() => handleFormController.openFormDialog('Tipo de quilometragem')}
								/>
								<AutoComplete
									disabled={registerFinished}
									id='tipokm'
									dropdown
									placeholder='Buscar...'
									value={mileagesValue}
									onChange={e => {
										setMileagesValue(e.value);
										getFormController.formik.setFieldValue(
											'FT_TIPOQUILOMETRAGEM',
											filteredMileages.find(mileage => {
												return e.value === mileage.label;
											})?.value || '',
										);
									}}
									onSelect={e => {
										getFormController.formik.setFieldValue('FT_TIPOQUILOMETRAGEM', e.value.value);
										setMileagesValue(e.value.label);
									}}
									suggestions={filteredMileages}
									field='label'
									completeMethod={searchMileages}
								/>
							</div>
							<div
								className={classNames('p-invalid popup-fade', {
									'popup-form-active':
										getFormController.formik.touched.FT_TIPOQUILOMETRAGEM &&
										getFormController.formik.errors.FT_TIPOQUILOMETRAGEM,
									'popup-form-inactive': !(
										getFormController.formik.touched.FT_TIPOQUILOMETRAGEM &&
										getFormController.formik.errors.FT_TIPOQUILOMETRAGEM
									),
								})}>
								{getFormController.formik.errors.FT_TIPOQUILOMETRAGEM}
							</div>
						</div>
						<div className='p-field p-col-12 p-md-3'>
							<label htmlFor='potCilindrada'>Potência/ Cilindrada</label>
							<InputText
								disabled={registerFinished}
								id='potCilindrada'
								maxLength={20}
								{...getFormController.formik.getFieldProps('CAPCIDADEPOTENCIACILINDRADA')}
								onChange={getFormController.formik.handleChange('CAPCIDADEPOTENCIACILINDRADA')}
							/>
							<div
								className={classNames('p-invalid popup-fade', {
									'popup-form-active':
										getFormController.formik.touched.CAPCIDADEPOTENCIACILINDRADA &&
										getFormController.formik.errors.CAPCIDADEPOTENCIACILINDRADA,
									'popup-form-inactive': !(
										getFormController.formik.touched.CAPCIDADEPOTENCIACILINDRADA &&
										getFormController.formik.errors.CAPCIDADEPOTENCIACILINDRADA
									),
								})}>
								{getFormController.formik.errors.CAPCIDADEPOTENCIACILINDRADA}
							</div>
						</div>
						<div className='p-field p-col-12 p-md-3'>
							<label htmlFor='especie'>Especie</label>
							<div className='p-inputgroup'>
								<Button
									type='button'
									icon='pi pi-plus'
									className='p-button p-button-primary '
									onClick={() => handleFormController.openFormDialog('Especie')}
								/>
								<AutoComplete
									disabled={registerFinished}
									id='especie'
									dropdown
									placeholder='Buscar...'
									value={especieValue}
									onChange={e => {
										setEspecieValue(e.value);
										getFormController.formik.setFieldValue(
											'FT_ESPECIE',
											filteredEspecie.find(Especie => {
												return e.value === Especie.label;
											})?.value || '',
										);
									}}
									onSelect={e => {
										getFormController.formik.setFieldValue('FT_ESPECIE', e.value.value);
										setEspecieValue(e.value.label);
									}}
									suggestions={filteredEspecie}
									field='label'
									completeMethod={searchEspecie}
								/>
							</div>
							<div
								className={classNames('p-invalid popup-fade', {
									'popup-form-active':
										getFormController.formik.touched.FT_ESPECIE &&
										getFormController.formik.errors.FT_ESPECIE,
									'popup-form-inactive': !(
										getFormController.formik.touched.FT_ESPECIE &&
										getFormController.formik.errors.FT_ESPECIE
									),
								})}>
								{getFormController.formik.errors.FT_ESPECIE}
							</div>
						</div>
						<div className='p-field p-col-12 p-md-3'>
							<label htmlFor='ctfReg'>Certificado Registro</label>
							<InputText
								disabled={registerFinished}
								id='ctfReg'
								maxLength={12}
								keyfilter='num'
								{...getFormController.formik.getFieldProps('CERTIFICADOREGISTRO')}
								onChange={getFormController.formik.handleChange('CERTIFICADOREGISTRO')}
							/>
							<div
								className={classNames('p-invalid popup-fade', {
									'popup-form-active':
										getFormController.formik.touched.CERTIFICADOREGISTRO &&
										getFormController.formik.errors.CERTIFICADOREGISTRO,
									'popup-form-inactive': !(
										getFormController.formik.touched.CERTIFICADOREGISTRO &&
										getFormController.formik.errors.CERTIFICADOREGISTRO
									),
								})}>
								{getFormController.formik.errors.CERTIFICADOREGISTRO}
							</div>
						</div>
						<div className='p-field p-col-12 p-md-3'>
							<label htmlFor='numMotor'>Número motor</label>
							<InputText
								disabled={registerFinished}
								id='numMotor'
								maxLength={25}
								{...getFormController.formik.getFieldProps('NUMEROMOTOR')}
								onChange={getFormController.formik.handleChange('NUMEROMOTOR')}
							/>
							<div
								className={classNames('p-invalid popup-fade', {
									'popup-form-active':
										getFormController.formik.touched.NUMEROMOTOR &&
										getFormController.formik.errors.NUMEROMOTOR,
									'popup-form-inactive': !(
										getFormController.formik.touched.NUMEROMOTOR &&
										getFormController.formik.errors.NUMEROMOTOR
									),
								})}>
								{getFormController.formik.errors.NUMEROMOTOR}
							</div>
						</div>

					</div>
					<div className='p-field p-col-12 p-md-2'>
						<label htmlFor='anoLicens'>Ano licenciamento</label>
						<InputText
							disabled={registerFinished}
							id='anoLicens'
							maxLength={4}
							{...getFormController.formik.getFieldProps('ANOLICENCIADO')}
							onChange={getFormController.formik.handleChange('ANOLICENCIADO')}
						/>
						<div
							className={classNames('p-invalid popup-fade', {
								'popup-form-active':
									getFormController.formik.touched.ANOLICENCIADO &&
									getFormController.formik.errors.ANOLICENCIADO,
								'popup-form-inactive': !(
									getFormController.formik.touched.ANOLICENCIADO &&
									getFormController.formik.errors.ANOLICENCIADO
								),
							})}>
							{getFormController.formik.errors.ANOLICENCIADO}
						</div>
					</div>
				</TabPanel>
			</TabView>


			<div className='p-fluid p-grid p-justify-between'>
				{getFormController.vehicleResponse?.status === 200 && !registerFinished ? (
					<div className='p-col-12 p-md-4'>
						<Button
							type='button'
							label='Salvar Alterações'
							onClick={() => {
								getFormController.formik.handleSubmit();
							}}
						/>
					</div>
				) : getFormController.vehicleResponse?.status === 200 && registerFinished ? (
					<div className='p-col-12 p-md-6 p-fluid p-grid'>
						<div className='p-col-12 p-md-5'>
							<Button
								type='button'
								label='Editar'
								onClick={() => {
									setRegisterFinished(false);
								}}
							/>
						</div>
						<div className='p-col-12 p-md-5'>
							<Button
								icon='pi pi-plus'
								type='button'
								className='p-button-success'
								label='Cadastrar novo'
								onClick={() => {
									getFormController.formik.resetForm();
									setCategoriesValue('');
									setMileagesValue('');
									setBrandsValue('');
									setStocksValue('');
									setValueUnity('');
									setEspecieValue('');
									setRegisterFinished(false);
									handleFormController.setVehicleResponse(null);
									handleDelete();
								}}
							/>
						</div>
					</div>
				) : (
					<div className='p-col-12 p-md-4'>
						<Button
							type='button'
							label='Cadastrar'
							onClick={() => getFormController.formik.handleSubmit()}
						/>
					</div>
				)}

				<div className='p-col-12 p-md-4'>
					<Button
						type='button'
						className='p-button-secondary'
						label='Voltar para listagem'
						onClick={() => history.goBack()}
					/>
				</div>
			</div>

			<Dialog
				style={{ width: '450px', height: '70%' }}
				contentStyle={{ height: '100%' }}
				visible={getFormController.formDialog && getFormController.selectedField === 'Estoque'}
				onHide={updateStocks}
				header={extraFormDialogHeader}
				closable={false}
				modal>
				<div
					className='confirmation-content p-fluid p-d-flex p-flex-column p-jc-between'
					style={{ height: '100%' }}>
					<div>
						<div className='p-field'>
							<label htmlFor='name'>Nome</label>
							<InputText
								id='name'
								type='text'
								value={getStockFormController.formik.values.NOME}
								onChange={getStockFormController.formik.handleChange('NOME')}
							/>
							<div
								className={classNames('p-invalid popup-fade', {
									'popup-form-active':
										getStockFormController.formik.touched.NOME &&
										getStockFormController.formik.errors.NOME,
									'popup-form-inactive': !(
										getStockFormController.formik.touched.NOME &&
										getStockFormController.formik.errors.NOME
									),
								})}>
								{getStockFormController.formik.errors.NOME}
							</div>
						</div>
						<div className='p-field'>
							<label htmlFor='unidade'>Unidade</label>
							<AutoComplete
								id='unidade'
								value={valueUnity}
								field='label'
								onChange={e => {
									setValueUnity(e.value);
									getStockFormController.formik.setFieldValue(
										'ORGAOUNIDADE',
										filteredUnity.find(unity => {
											return e.value === unity.label;
										})?.value || '',
									);
									getFormController.formik.setFieldValue(
										'ORGAOUNIDADE',
										filteredUnity.find(unity => {
											return e.value === unity.label;
										})?.value || '',
									);
								}}
								onSelect={e => {
									setValueUnity(e.value.label);
									getStockFormController.formik.setFieldValue('ORGAOUNIDADE', e.value.value);
									getFormController.formik.setFieldValue('ORGAOUNIDADE', e.value.value);
								}}
								suggestions={filteredUnity}
								completeMethod={searchUnitys}
								dropdown
								placeholder='Buscar...'
								dropdownMode='current'
							/>
							<div
								className={classNames('p-invalid popup-fade', {
									'popup-form-active':
										getStockFormController.formik.touched.ORGAOUNIDADE &&
										getStockFormController.formik.errors.ORGAOUNIDADE,
									'popup-form-inactive': !(
										getStockFormController.formik.touched.ORGAOUNIDADE &&
										getStockFormController.formik.errors.ORGAOUNIDADE
									),
								})}>
								{getStockFormController.formik.errors.ORGAOUNIDADE}
							</div>
						</div>
					</div>
					<div>
						<Button
							type='submit'
							label='Cadastrar'
							onClick={() => getStockFormController.formik.handleSubmit()}
						/>
					</div>
				</div>
				{getStockFormController.loading ? <LoadingScreen color='#0388e5' /> : <></>}
			</Dialog>

			<Dialog
				style={{ width: '450px' }}
				contentStyle={{ height: '100%' }}
				visible={getFormController.formDialog && getFormController.selectedField === 'Marca'}
				onHide={updateBrands}
				header={extraFormDialogHeader}
				closable={false}
				modal>
				<div className='confirmation-content p-fluid'>
					<div className='p-field'>
						<label htmlFor='name'>Nome</label>
						<InputText
							id='name'
							type='text'
							value={getBrandFormController.formik.values.DESCRICAO}
							onChange={getBrandFormController.formik.handleChange('DESCRICAO')}
						/>
						<div
							className={classNames('p-invalid popup-fade', {
								'popup-form-active':
									getBrandFormController.formik.touched.DESCRICAO &&
									getBrandFormController.formik.errors.DESCRICAO,
								'popup-form-inactive': !(
									getBrandFormController.formik.touched.DESCRICAO &&
									getBrandFormController.formik.errors.DESCRICAO
								),
							})}>
							{getBrandFormController.formik.errors.DESCRICAO}
						</div>
					</div>
					<Button
						type='submit'
						label='Cadastrar'
						onClick={() => getBrandFormController.formik.handleSubmit()}
					/>
				</div>
				{getBrandFormController.loading ? <LoadingScreen color='#0388e5' /> : <></>}
			</Dialog>

			<Dialog
				style={{ width: '450px' }}
				contentStyle={{ height: '100%' }}
				visible={getFormController.formDialog && getFormController.selectedField === 'Especie'}
				onHide={updateEspecies}
				header={extraFormDialogHeader}
				closable={false}
				modal>
				<div className='confirmation-content p-fluid'>
					<div className='p-field'>
						<label htmlFor='name'>Nome</label>
						<InputText
							id='name'
							type='text'
							value={getEspecieFormController.formik.values.DESCRICAO}
							onChange={getEspecieFormController.formik.handleChange('DESCRICAO')}
						/>
						<div
							className={classNames('p-invalid popup-fade', {
								'popup-form-active':
									getEspecieFormController.formik.touched.DESCRICAO &&
									getEspecieFormController.formik.errors.DESCRICAO,
								'popup-form-inactive': !(
									getEspecieFormController.formik.touched.DESCRICAO &&
									getEspecieFormController.formik.errors.DESCRICAO
								),
							})}>
							{getEspecieFormController.formik.errors.DESCRICAO}
						</div>
					</div>
					<Button
						type='submit'
						label='Cadastrar'
						onClick={() => getEspecieFormController.formik.handleSubmit()}
					/>
				</div>
				{getEspecieFormController.loading ? <LoadingScreen color='#0388e5' /> : <></>}
			</Dialog>

			<Dialog
				style={{ width: '450px' }}
				contentStyle={{ height: '100%' }}
				visible={getFormController.formDialog && getFormController.selectedField === 'Categoria'}
				onHide={updateCategorys}
				header={extraFormDialogHeader}
				closable={false}
				modal>
				<div className='confirmation-content p-fluid'>
					<div className='p-field'>
						<label htmlFor='name'>Nome</label>
						<InputText
							id='name'
							type='text'
							value={getCategoryFormController.formik.values.DESCRICAO}
							onChange={getCategoryFormController.formik.handleChange('DESCRICAO')}
						/>
						<div
							className={classNames('p-invalid popup-fade', {
								'popup-form-active':
									getCategoryFormController.formik.touched.DESCRICAO &&
									getCategoryFormController.formik.errors.DESCRICAO,
								'popup-form-inactive': !(
									getCategoryFormController.formik.touched.DESCRICAO &&
									getCategoryFormController.formik.errors.DESCRICAO
								),
							})}>
							{getCategoryFormController.formik.errors.DESCRICAO}
						</div>
					</div>
					<Button
						type='submit'
						label='Cadastrar'
						onClick={() => getCategoryFormController.formik.handleSubmit()}
					/>
				</div>
				{getCategoryFormController.loading ? <LoadingScreen color='#0388e5' /> : <></>}
			</Dialog>

			<Dialog
				style={{ width: '450px' }}
				contentStyle={{ height: '100%' }}
				visible={getFormController.formDialog && getFormController.selectedField === 'Tipo de quilometragem'}
				onHide={updateMileages}
				header={extraFormDialogHeader}
				closable={false}
				modal>
				<div className='confirmation-content p-fluid'>
					<div className='p-field'>
						<label htmlFor='name'>Nome</label>
						<InputText
							id='name'
							type='text'
							value={getMileageFormController.formik.values.DESCRICAO}
							onChange={getMileageFormController.formik.handleChange('DESCRICAO')}
						/>
						<div
							className={classNames('p-invalid popup-fade', {
								'popup-form-active':
									getMileageFormController.formik.touched.DESCRICAO &&
									getMileageFormController.formik.errors.DESCRICAO,
								'popup-form-inactive': !(
									getMileageFormController.formik.touched.DESCRICAO &&
									getMileageFormController.formik.errors.DESCRICAO
								),
							})}>
							{getMileageFormController.formik.errors.DESCRICAO}
						</div>
					</div>
					<Button
						type='submit'
						label='Cadastrar'
						onClick={() => getMileageFormController.formik.handleSubmit()}
					/>
				</div>
				{getMileageFormController.loading ? <LoadingScreen color='#0388e5' /> : <></>}
			</Dialog>

			<Dialog
				style={{ width: '450px' }}
				contentStyle={{ height: '100%' }}
				visible={getFormController.formDialog && getFormController.selectedField === 'Tipo de combustível'}
				onHide={updateFuels}
				header={extraFormDialogHeader}
				closable={false}
				modal>
				<div className='confirmation-content p-fluid'>
					<div className='p-field'>
						<label htmlFor='name'>Nome</label>
						<InputText
							id='name'
							type='text'
							value={getFuelFormController.formik.values.DESCRICAO}
							onChange={getFuelFormController.formik.handleChange('DESCRICAO')}
						/>
						<div
							className={classNames('p-invalid popup-fade', {
								'popup-form-active':
									getFuelFormController.formik.touched.DESCRICAO &&
									getFuelFormController.formik.errors.DESCRICAO,
								'popup-form-inactive': !(
									getFuelFormController.formik.touched.DESCRICAO &&
									getFuelFormController.formik.errors.DESCRICAO
								),
							})}>
							{getFuelFormController.formik.errors.DESCRICAO}
						</div>
					</div>
					<Button
						type='submit'
						label='Cadastrar'
						onClick={() => getFuelFormController.formik.handleSubmit()}
					/>
				</div>
				{getFuelFormController.loading ? <LoadingScreen color='#0388e5' /> : <></>}
			</Dialog>
		</div>
	);
};

export default VehicleForm;
